/* eslint import/prefer-default-export:0 */

// 1 hr
export const MAX_CACHE_TIME = 60 * 60 * 1000;
